import { render, staticRenderFns } from "./TripOrderOverview.vue?vue&type=template&id=51d3ad6a&"
import script from "./TripOrderOverview.vue?vue&type=script&lang=js&"
export * from "./TripOrderOverview.vue?vue&type=script&lang=js&"
import style0 from "./TripOrderOverview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports